import { createAsyncThunk } from "@reduxjs/toolkit";

import {
    getModelList as getModelListApi,
    addModelList as addModelListApi,
    updateModelList as updateModelListApi,
    deleteModelList as deleteModelListApi
} from "../../helpers/helper";
import { toast } from "react-toastify";

export const getModelList = createAsyncThunk("Model/getModelList", async () => {
    try {
        const response = await getModelListApi();
        return response;
    } catch (error) {
        return error;
    }
});

export const addModelList = createAsyncThunk("Model/addModelList", async (category: any) => {
    try {
        const response = addModelListApi(category);
        const data = await response;
        toast.success("Model Added Successfully", { autoClose: 2000 });
        return data;
    } catch (error) {
        toast.error("Model Added Failed", { autoClose: 2000 });
        return error;
    }
});

export const updateModelList = createAsyncThunk("Model/update", async (dataArr: any) => {
    try {
        const response = updateModelListApi(dataArr);
        const data = await response;
        toast.success("Model Updated Successfully", { autoClose: 2000 });
        return data;
    } catch (error) {
        toast.error("Model Updated Failed", { autoClose: 2000 });
        return error;
    }
});

export const deleteModelList = createAsyncThunk("Model/deleteModelList", async (categoryId: any) => {
    try {
        const response = deleteModelListApi(categoryId);
        console.log(response);
        toast.success("Model Deleted Successfully", { autoClose: 2000 });
        return categoryId;
    } catch (error) {
        toast.error("Model Deleted Failed", { autoClose: 2000 });
        return error;
    }
})
